enum ViewType
{
	verifyCoverage,
	homeUse,
	personalizedQuote,
	phonePlan,
	offer,
	offers,
	plan,
	radio,
	checkbox,
	progressBar,
	currentNumber,
	portabilityNumber,
	wifiCoverage,
	enterEmail,
	firstDataPage,
	secondDataPage,
	voicePackages,
	optionsView,
	paymentType,
	paymentMode,
	bankForm,
	documentsUpload,
	taxIdCode,
	lastPage
}

export default ViewType
